import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from "@angular/http";
import 'rxjs/Rx';
import { LoadingController, Events } from "ionic-angular";
import { EbsWebServiceGlobals } from "./ebsWebServiceGlobals";
import { Storage } from '@ionic/storage';
import { ImageViewerController } from "ionic-img-viewer";



@Injectable()
export class EbsWebService {

  _imageViewerCtrl: ImageViewerController;
  constructor(private http: Http,
    public loadingCtrl: LoadingController,
    imageViewerCtrl: ImageViewerController,
    public events: Events,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals,
    private _storage: Storage) {
    this._imageViewerCtrl = imageViewerCtrl;
  }

  getData(url) {
    console.error("GET is deprecated!")
    if (url.indexOf("userKey=&") != -1) {
      var userhash = "userKey=" + this._ebsWebServiceGlobals.getUserHash();
      url = url.replace("userKey=", userhash);
    }

    var options = new RequestOptions({
      headers: new Headers({
        'Accept': 'application/json'
      })
    });

    let response = this.http.request(url, options)
      .map(res => res.json());

    //this.setDebugMessage(response,url);

    return response;
  }

  postData(actionURL, params, requestOptions = null) {
    if (params == null) {
      params = this.buildPostPayloadObjectFromGetParameters("userKey=" + this._ebsWebServiceGlobals.getUserHash());
    }

    if (requestOptions == null) {
      requestOptions = new RequestOptions({
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      });
    }
    let response = this.http.post(actionURL, params, requestOptions).map(res => {
      let mappedResponse = JSON.parse(res.text().replace('{"d":null}', ""));
      this.checkIfUserIsLoggedIn(mappedResponse);
      this.setDebugMessage(mappedResponse, actionURL, params);
      return mappedResponse;
    });

    return response;
  }

  checkIfUserIsLoggedIn(response) {
    if (response != null && this._ebsWebServiceGlobals.getUserHash() != "" && this._ebsWebServiceGlobals.getUserHash() != null && response.LoginUrl != null && response.LoginUrl != "" && typeof response.LoginUrl != "undefined") {
      this._ebsWebServiceGlobals.setUserHash('');
      this._ebsWebServiceGlobals.setLoginUrl(response.LoginUrl);
      this._ebsWebServiceGlobals.setShowLoginScreen(true);
      window.location.reload();
    }
  }


  buildPostPayloadObjectFromGetParameters(getParams) {
    if (typeof getParams == "undefined" || getParams == null) {
      return null;
    }
    let paramsArray = getParams.split("&");
    let paramsObject = {};
    paramsArray.forEach(element => {
      let elementParts = element.split("=");
      let value = element.slice(elementParts[0].length + 1);
      paramsObject[elementParts[0]] = value;
    });
    return JSON.stringify(paramsObject);
  }

  setDebugMessage(response, url, params) {
    if (this._ebsWebServiceGlobals.getParameterByName("debug")) {
      if (response != null && typeof response != "undefined" && response.DebugInfo != "") {
        this._ebsWebServiceGlobals.setDebugMessage(response.DebugInfo);
        this._ebsWebServiceGlobals.setDebugUrl(url.replace("AsJSON", "AsXML"));
        this._ebsWebServiceGlobals.setDebugPostParams(params);
      };
      this._ebsWebServiceGlobals.setShowDebugMessage(true);
    }
  }

  setIconsInStorage(iconsArray) {
    iconsArray.forEach((icon, key, arr) => {
      if (Object.is(arr.length - 1, key)) {
        this._storage.set(icon.Key, icon.IconBase64).then(() => {
          //window.location.reload();
        });
      } else {
        this._storage.set(icon.Key, icon.IconBase64);
      }
    });
  }

  async getIconsLastChangeDate() {
    let lastChangeDate = await this._storage.get('iconshash').then((val) => {
      return val;
    });

    return lastChangeDate;
  }

  setIconsLastChangeDate(lastChangeDate) {
    let userKey = this._ebsWebServiceGlobals.getUserHash();
    localStorage.clear();
    sessionStorage.clear();
    this._storage.clear();
    this._ebsWebServiceGlobals.setUserHash(userKey);
    sessionStorage.setItem('iconshash', lastChangeDate);
    this._storage.set('iconshash', lastChangeDate);
  }

  getIconFromStorage(key) {
    if (key.includes("data:image/")) {
      return key;
    }
    return this._storage.get(key);
  }

  prepareWebServiceDataForView(webServiceData) {

    if (webServiceData == null || webServiceData.ListItemContent == null) {
      return;
    }

    let webServiceDataProcessed = { "header": null, "body": null, "footer": null, "unused": null };

    let header = {
      titleimage: new Array(),
      title: new Array(),
      subtitle: new Array(),
      headerIconLeft: new Array(),
      headerIconRight: new Array(),
      icons: new Array()
    };
    webServiceDataProcessed.header = header;

    let body = new Array();
    webServiceDataProcessed.body = body;

    let footer = {
      gallery: new Array(),
      table: new Array()
    };
    webServiceDataProcessed.footer = footer;

    let unused = new Array();
    webServiceDataProcessed.unused = unused;

    webServiceData.ListItemContent.forEach(element => {
      let templateIdentifier = element.TemplateIdentifier;
      if (templateIdentifier != null && templateIdentifier != undefined) {
        templateIdentifier = templateIdentifier.split('_')[0];
      }
      switch (templateIdentifier) {
        case "TitleImage":
          webServiceDataProcessed["header"].titleimage.push(element);
          break;
        case "Title":
          webServiceDataProcessed["header"].title.push(element);
          break;
        case "Subtitle":
          webServiceDataProcessed["header"].subtitle.push(element);
          break;
        case "HeaderIconLeft":
          webServiceDataProcessed["header"].headerIconLeft.push(element);
          break;
        case "HeaderIconRight":
          webServiceDataProcessed["header"].headerIconRight.push(element);
          break;
        case "Icons":
          webServiceDataProcessed["header"].icons.push(element);
          break;
        case "BodyLeft":
          this.addBody(webServiceDataProcessed["body"], element, 'left');
          //webServiceDataProcessed["body"].bodyLeft.push(element);
          break;
        case "BodyRight":
          this.addBody(webServiceDataProcessed["body"], element, 'right');
          //webServiceDataProcessed["body"].bodyRight.push(element);
          break;
        case "BodyFull":
          this.addBody(webServiceDataProcessed["body"], element, 'full');
          break;
        case "Table":
          webServiceDataProcessed["footer"].table.push(element);
          break;
        default:
          webServiceDataProcessed["unused"].push(element);
          break;
      }

    });

    return webServiceDataProcessed;
  }

  addBody(body, element, position) {
    let bodyIdentifier;
    let splitIdentifier = element.TemplateIdentifier.split('_');
    if (splitIdentifier.length == 1) {
      bodyIdentifier = 'Default';
    } else {
      bodyIdentifier = splitIdentifier[1];
    }
    let needle = body.find(bodyElement => bodyElement.identifier == bodyIdentifier);
    if (needle == undefined) {
      let arr = [element];
      body.push({ identifier: bodyIdentifier, left: position == 'left' ? arr : [], right: position == 'right' ? arr : [], full: position == 'full' ? arr : [] });
    } else {
      if (position == 'left') {
        needle.left.push(element);
      } else if (position == 'right') {
        needle.right.push(element);
      } else if (position == 'full') {
        needle.full.push(element);
      }
    }
  }

  setBrowserTabTitle(title) {
    if (typeof title != "undefined" && title != "") {
      document.title = title;
    }
  }

  downloadFile(downloadURL, downloadParams) {
    let postPayloadObject = this.buildPostPayloadObjectFromGetParameters(downloadParams);
    this.postData(downloadURL, postPayloadObject).subscribe(res => {
      // open in new tab and not in same tab ¯\_(ツ)_/¯
      //window.location.assign(res.DownloadURL);
      open(res.DownloadURL);
    });
  }

  openPopUp(fullImage, ActionUrl, PostParameters) {
    console.log(fullImage);
    //open(ActionUrl, 'popup', 'height=400,width=400,resizable=yes');
    let postPayloadObject = this.buildPostPayloadObjectFromGetParameters(PostParameters);
    this.postData(ActionUrl, postPayloadObject).subscribe(res => {
      console.log(res);
      let object = {  image: res.DownloadURL, enableBackdropDismiss: true };
      //window.open(res.DownloadURL, '_blank').focus();
      //fullImage.setAttribute('imageViewer', res.DownloadURL);
      const imageViewer = this._imageViewerCtrl.create(fullImage, object);
      imageViewer.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/ebsWebService.ts